import { render, staticRenderFns } from "./BooleanEditor.vue?vue&type=template&id=6887b7ca&scoped=true&"
import script from "./BooleanEditor.vue?vue&type=script&lang=js&"
export * from "./BooleanEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887b7ca",
  null
  
)

export default component.exports